import Vue,{provide,ref,createApp } from 'vue'
import App from './App.vue'
import store from './store'
import { createRouter,  createWebHistory } from 'vue-router'
import {routes as allRoutes} from './router'
import { createVuetify } from 'vuetify'
import 'vuetify/styles';
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import '@mdi/font/css/materialdesignicons.css'
import { aliases, mdi } from "vuetify/iconsets/mdi"
import 'bootstrap/dist/css/bootstrap.css'
import '@fortawesome/fontawesome-free/css/all.css'
import "./app.scss"
import { i18n } from './app-i18n';
// import Toast from "vue-toastification";
// import "vue-toastification/dist/index.css";
import { readonly } from 'vue'
import { keycloakInit } from '../public/common/vue/api/leanbot_js_api';
const userdata = ref(keycloakInit.catch());




window.conf=conf;
export function createPage(routes:any) {
    const vuetify = createVuetify({
        components,
        directives,
        icons: {
          defaultSet: 'mdi',
          aliases,
          sets: {
            mdi,
          },
        },
      });
      // Vue.use(Toast, {});
      var app:any=createApp(App);
      app.provide('userdata', readonly(userdata));
      app.use(i18n).use(vuetify)
      // .use(Toast, {})
      .use(store).use(createRouter({
        history: createWebHistory(), 
        routes: allRoutes.concat(routes||[]),
        linkActiveClass: 'active'
      })).mount('#app')
      
}




